import { useI18n } from "@core/i18n/i18n";
import styled from "@emotion/styled";
import { Button } from "@ui/components/buttons/button";
import { row } from "@ui/style";
import React from "react";

interface ShareUsingPrintFormProps {
	onSuccess?: () => void;
}

export const ShareUsingPrintForm = ({ onSuccess }: ShareUsingPrintFormProps): JSX.Element => {
	const { format } = useI18n();
	return (
		<ButtonContainer>
			<Button
				label={format("home.pendingPatientDialog.printButton")}
				onClick={() => {
					onSuccess?.();
				}}
			/>
		</ButtonContainer>
	);
};

const ButtonContainer = styled.div`
	padding-top: 0.75rem;
	${row(undefined, "flexend")};
	flex-grow: 1;
	height: 100%;
`;
